import { Injectable } from '@angular/core';
import { MediaHavenPlugin } from '../../modules/entities/mediahaven-plugins.entity';
import { PluginGuard } from '../../modules/guards/plugin.guard';

@Injectable({
    providedIn: 'root'
})
export class FacialRecognitionGuard extends PluginGuard {
    protected PLUGINS_TO_CHECK: MediaHavenPlugin[] = [MediaHavenPlugin.FACIAL_RECOGNITION_DEEP_FACE];
}
